import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Injectable } from '@angular/core';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { IListByFilterSetups, ISetup, ModuleConfig } from '../models/setup.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetupService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Setup`;

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  listSetups(filter: IListByFilterSetups): Observable<ResponseDefault<ISetup[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      orderBy: filter.orderBy.toString()
    });

    if (filter.companyId) {
      params = params.append('companyId', filter.companyId);
    }
    if (filter.active) {
      params = params.append('active', filter.active);
    }
    if (filter.searchText) {
      params = params.append('searchText', filter.searchText);
    }

    return this.http.get<ResponseDefault<ISetup[]>>(`${this.apiUrl}/ListByFilterAsync`, { params });
  }

  addSetup(setup: ISetup): Observable<ResponseDefault<ISetup>> {
    return this.http.post<ResponseDefault<ISetup>>(`${this.apiUrl}`, setup);
  }

  getSetupById(id: string): Observable<ResponseDefault<ISetup>> {
    return this.http.get<ResponseDefault<ISetup>>(`${this.apiUrl}/${id}`);
  }

  editSetup(id: string, setup: ISetup): Observable<ResponseDefault<ISetup>> {
    return this.http.put<ResponseDefault<ISetup>>(`${this.apiUrl}/${id}`, setup);
  }

  removeModule(setupId: string, moduleId: string): Observable<ResponseDefault<ISetup>> {
    return this.http.delete<ResponseDefault<ISetup>>(`${this.apiUrl}/${setupId}/Module/${moduleId}`);
  }

  addConfigModule(id: string, moduleId: string, config: any): Observable<ResponseDefault<any>> {
    return this.http.post<ResponseDefault<any>>(`${this.apiUrl}/${id}/Module/${moduleId}`, config);
  }

  getConfigModule(id: string, moduleId: string): Observable<ResponseDefault<ModuleConfig>> {
    return this.http.get<ResponseDefault<ModuleConfig>>(`${this.apiUrl}/${id}/Module/${moduleId}/ConfigModule`);
  }

  updateModuleFlags(setupId: string, moduleId: string, model: { requiresAuth: boolean; requiresTriage: boolean }): Observable<ResponseDefault<any>> {
    return this.http.put<ResponseDefault<any>>(`${this.apiUrl}/${setupId}/Module/${moduleId}/flags`, model);
  }
}
